/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */

import React from 'react';
import './LoanDataDisplay.scss';
import fmt from 'indian-number-format';

// Define TypeScript interfaces
interface LoanItem {
  part: string;
  branch: string;
  totalActiveLoans?: number;
  totalPrincipalOutstanding?: number;
  totalInterestOutstanding?: number;
  totalLoanOutstanding?: number;
  totalRefinancedLoans?: number;
  totalPrincipalOutstandingRefinanced?: number;
  totalInterestOutstandingRefinanced?: number;
  totalLoanOutstandingRefinanced?: number;
}

interface LoanDataProps {
  data: LoanItem[];
}

const partNameMapping: Record<string, string> = {
  'Part-1': 'Customer Loan',
  'Part-2': 'OB Loan',
};

const LoanDataDisplay: React.FC<LoanDataProps> = ({ data }) => {
  const groupedData = data.reduce((acc: Record<string, LoanItem[]>, item) => {
    if (!acc[item.part]) acc[item.part] = [];
    acc[item.part].push(item);
    return acc;
  }, {});

  return (
    <div className="loan-data-container">
      {Object.entries(groupedData).map(([part, items]) => {
        const totalRow = items.find((item) => item.branch === 'Total');
        const branchRows = items.filter((item) => item.branch !== 'Total');

        return (
          <div key={part} className="part-section">
            <h2>{partNameMapping[part] || part}</h2>
            <table className="loan-table">
              <thead>
                <tr>
                  <th>Branch</th>
                  <th>Active Loans</th>
                  <th>Principal Outstanding</th>
                  <th>Interest Outstanding</th>
                  <th>Total Loan Outstanding</th>
                </tr>
              </thead>
              <tbody>
                {branchRows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.branch}</td>
                    <td>
                      {row.totalActiveLoans || row.totalRefinancedLoans || 0}
                    </td>
                    <td>
                      {fmt.format(
                        row.totalPrincipalOutstanding ||
                          row.totalPrincipalOutstandingRefinanced ||
                          0
                      )}
                    </td>
                    <td>
                      {fmt.format(
                        row.totalInterestOutstanding ||
                          row.totalInterestOutstandingRefinanced ||
                          0
                      )}
                    </td>
                    <td>
                      {fmt.format(
                        row.totalLoanOutstanding ||
                          row.totalLoanOutstandingRefinanced ||
                          0
                      )}
                    </td>
                  </tr>
                ))}
                {totalRow && (
                  <tr className="total-row">
                    <td>
                      <strong>{totalRow.branch}</strong>
                    </td>
                    <td>
                      <strong>
                        {totalRow.totalActiveLoans ||
                          totalRow.totalRefinancedLoans ||
                          0}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        {fmt.format(
                          totalRow.totalPrincipalOutstanding ||
                            totalRow.totalPrincipalOutstandingRefinanced ||
                            0
                        )}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        {fmt.format(
                          totalRow.totalInterestOutstanding ||
                            totalRow.totalInterestOutstandingRefinanced ||
                            0
                        )}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        {fmt.format(
                          totalRow.totalLoanOutstanding ||
                            totalRow.totalLoanOutstandingRefinanced ||
                            0
                        )}
                      </strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

export default LoanDataDisplay;
